import { z } from 'zod';
import { PixKeyTypeSchema } from "./pix-key-type.dto.js";
export const BaseBankAccountDTOSchema = z.object({
    id: z.string().uuid(),
    bankCode: z.string().min(1).max(3),
    branchNumber: z.string().min(1).max(10),
    accountNumber: z.string().min(1).max(15),
    legalName: z.string().nullable(),
    pixKey: z.string().nullable(),
    pixKeyType: PixKeyTypeSchema.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    isDeleted: z.boolean(),
});
export const ExposedBankAccountDTOSchema = BaseBankAccountDTOSchema.omit({
    isDeleted: true,
    deletedAt: true,
});
//# sourceMappingURL=bank-accounts.dto.js.map